import React, { useEffect } from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import Home from 'components/Home'
import { StoriesStore } from 'stores/stories'
import { useFeedPageView, useDatePagination, useStore } from 'hooks'
import { getStaticWrapper } from 'utils'
import optimize from 'lib/pixels/optimize'

const HomePage = ({ items, featuredItems, trendingItems }) => {
  const storiesStore = useStore(StoriesStore, { items, featuredItems, trendingItems })
  const pagination = useDatePagination(storiesStore.items, (query) => storiesStore.findNext(query))
  useFeedPageView(pagination)

  const adSettings = {
    slot: 'home',
    revContentSlot: 'Homepage',
    keyValues: {}
  }
  useEffect(() => {
    optimize.activate('optimize.activate')
    optimize.activate('optimize.activate.blogA_A')
  }, [])
  return (
    <>
      <SiteLayout adSettings={adSettings}>
        <Head
          title='Barstool Sports'
          description='Barstool Sports is a sports & pop culture blog covering the latest news and viral highlights of each and everyday with blogs, videos and podcasts.  By the common man, for the common man.'
        />
        <Home {...pagination} adSettings={adSettings} />
      </SiteLayout>
    </>
  )
}

export const getStaticProps = getStaticWrapper(async () => {
  const [items, featuredItems, trendingItems] = await Promise.all([
    StoriesStore().find(),
    StoriesStore().find({ featured: true, limit: 3 }),
    StoriesStore().findTrending({ exclude_featured: true, limit: 5 })
  ])
  return {
    items,
    featuredItems,
    trendingItems
  }
})

export default HomePage
